export default function Features() {
  const features = [
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      desc: '全站资源均为高清及以上画质，带来影院级视觉享受',
    },
    {
      icon: 'ri-speed-up-line',
      title: '流畅不缓冲',
      desc: '采用高速服务器和CDN加速技术，播放流畅无卡顿',
    },
    {
      icon: 'ri-movie-2-line',
      title: '海量资源',
      desc: '聚合全网热门电影电视剧资源，超过950部影视作品持续更新',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: '完美支持电脑、平板和手机访问，随时随地享受观影',
    },
  ];

  return (
    <section className="w-full py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              为什么选择被窝网电影
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              用心打造最佳观影体验平台
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex flex-col items-center text-center p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className={`${f.icon} text-2xl`} />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}